import $ from 'jquery'

$(document).ready(function() {
  co_new()
})

function co_new() {
  $('.co_new').each(function() {})
}
